// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"EmptyState_emptyState___ZMAh","emoji":"EmptyState_emoji__3veCW","title":"EmptyState_title__2GIdg","body":"EmptyState_body__shrGq"};